<template>
  <nav
    class="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white"
    id="sidenav-main"
    @mouseover="showSidebar"
    @mouseleave="closeSidebar"
    v-click-outside="outsideClick"
  >
    <div
      class="scroll-wrapper scrollbar-inner"
      style="position: relative;    overflow-y: auto !important;"
    >
      <div
        class="scrollbar-inner scroll-content"
        style="margin-bottom: 0px; margin-right: 0px; max-height: none;"
      >
        <!-- Brand -->
        <div class="sidenav-header d-flex align-items-center">
          <router-link class="navbar-brand" to="/">
            <img :src="logo" class="navbar-brand-img" alt="..." />
          </router-link>
          <div class="ml-auto">
            <!-- Sidenav toggler -->
            <!--Toggler-->
            <navbar-toggle-button class="d-none" @click.native="toggleSidebar">
            </navbar-toggle-button>
            <button @click="toggleSidebar" class="btn d-xl-none mr-2">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
        <div class="navbar-inner">
          <!-- Collapse -->
          <div class="collapse navbar-collapse" id="sidenav-collapse-main">
            <!-- Nav items -->
            <ul class="navbar-nav">
              <slot name="links"> </slot>
            </ul>

            <button
              @click="toggleSidebar"
              class="btn btn-block btn-outline-primary mt-6 d-xl-none"
            >
              Đóng menu
            </button>
          </div>
        </div>
      </div>
      <div class="scroll-element scroll-x">
        <div class="scroll-element_outer">
          <div class="scroll-element_size"></div>
          <div class="scroll-element_track"></div>
          <div class="scroll-bar" style="width: 0px; left: 0px;"></div>
        </div>
      </div>
      <div class="scroll-element scroll-y">
        <div class="scroll-element_outer">
          <div class="scroll-element_size"></div>
          <div class="scroll-element_track"></div>
          <div class="scroll-bar" style="height: 0px;"></div>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import SideBarState from "./SideBarState";
import NavbarToggleButton from "@/components/BaseComponents/NavbarToggleButton";
export default {
  name: "sidebar",
  components: {
    NavbarToggleButton
  },
  enums: {
    SideBarState
  },
  props: {
    logo: {
      type: String,
      default: "/img/brand/green.png",
      description: "Sidebar app logo"
    },
    autoClose: {
      type: Boolean,
      default: false,
      description:
        "Whether sidebar should autoclose on mobile when clicking an item"
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    closeSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    showSidebar() {
      this.$sidebar.displaySidebar(true);
    },
    outsideClick() {
      this.$sidebar.outsideClick();
    },
    toggleSidebar() {
      this.$sidebar.doPinSidebar(!this.$sidebar.pinSidebar);
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
